import React, { FC } from 'react';

export const SubdomainList: FC = ({ children }) => {
	return (
		<ul className="w-60 bg-gray-200 dark:bg-gray-400 inline-block h-full border-r-2 border-gray-100 dark:border-app-gunmetal">
			{children}
		</ul>
	);
};
